import React, { Children } from "react";
import "./ClassIDLabel.css"

function ClassIDLabel({class_id, isWhite}) {
    return (
        <div className="class-id-label" style={{color: isWhite ? "white" : "black"}}>Class ID: {class_id}</div>
    )
}

export default ClassIDLabel;